module.exports = __webpack_public_path__ + "701ec16134eec734cf95e17bf532a37b.svg";